module.exports = __webpack_public_path__ + "static/media/home-layers@2x.1256707b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-layers@2x.png
// module id = 546
// module chunks = 0